// @flow

import { getWeekDay } from './get-week-day';
import type { Country } from '../country';

export function getWeekDayByCountry(dueDate: string, country: Country): string {
  return getWeekDay(dueDate, getWeekDayList(country));
}

function getWeekDayList(country): Array<string> {
  switch (country) {
    case 'co':
      return ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    default:
      throw new Error('Week day by country - Not implemented yet');
  }
}
